import React from 'react'
import { fetchScoreBoardInfo, fetchPlayersByTournament, fetchPlayersScoreByTournament } from '../../../api/ScoreBoard';
import { CardImg, Button, Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, InputGroup, Label, Row, Table, Container } from 'reactstrap';
import Switch from 'react-switch';
import moment from 'moment';
import QRCode from 'easyqrcodejs';
import '../../../views/Home/TournamentedEntry/ScoreBoard/style.css';
import { fetchTournamentedSponsorIds, getSponsorsImages } from '../../../api/Tournamented';
import logo from './../../../assets/img/brand/golf-ball.ico'
import { LoadingSpinner } from '../../../components';
import AlertExpire from '../../../components/AlertExpire';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import VerticalCarousel from '../../../components/ImageSlider/VerticalCarousel';
class MasterScoreBoard extends React.Component {
    constructor(props) {
        super(props);
        this.qrcode = React.createRef();
        this.state = {
            Title: '',
            name: '',
            Course: '',
            pars: Array.from(Array(18).fill(0)),
            hlightIndex: -1,
            tournamentDate: '',
            memberScoreMethod: '',
            guestScoreMethod: '',
            MemberHiddenHoles: '',
            GuestHiddenHoles: '',
            memberCount: 0,
            guestCount: 0,
            memberTotalPars: 0,
            gTotalPars: 0,
            groupGuestScore: false,
            groupMemberScoreByHandicap: false,
            handicapValue: 0,

            sponsorsIds: "",
            switchOn: false,
            timerRefresh: 0.5,
            myInterval: undefined,
            sortBy: [false, ""],
            records: [],
            sortData: [],
            members: [],
            guests: [],
            membersOver: [],
            membersUnder: [],
            sponsorsImages: [],
            sortColums: [],
            rowKey: "",
            showType: "",
            isLoading: false,
            dropDownOpen: false,
            isExpired: false,
            options: {},
        }
    }
    createInterval() {
        let myInterval = setInterval(() => {
            this.loadData(this.state.sortColums);
        }, (this.state.timerRefresh * 60000));
        this.setState({ myInterval });
    }
    async componentDidMount() {
        this.props.keepUser({ key: 'check', name: 'checker', userId: 'check', isAuth: true, forceToChangePW: false })
        let { sponsorsIds, sponsorsImages } = this.state;
        if (this.props.match.params.id) {
            let rowKey = this.props.match.params.id;
            let showType = this.props.match.params.type;
            // console.log(window.location.href)
            let options = {
                text: window.location.href, //this.props.location.pathname,
                width: 90,
                height: 90,
                logo: logo,
            }
            let response = await fetchTournamentedSponsorIds(rowKey);
            this.setState({
                rowKey,
                showType,
                sponsorsIds: response.data.sponsorIds,
                options,
            }, async () => {
                new QRCode(this.qrcode.current, this.state.options);
                if (sponsorsIds !== "" || sponsorsIds !== null) {
                    let resImges = await getSponsorsImages(response.data.sponsorIds)
                    if (resImges.length > 0) {
                        resImges.map((path, index) => {
                            sponsorsImages.push({ key: index, content: <img style={{ borderRadius: '8px' }} draggable="false" width="550" height="300" src={path}></img> })
                        })
                        this.setState({
                            sponsorsImages
                        })
                    }
                }
                this.loadData(this.state.sortColums)
                if (this.state.switchOn) {
                    this.createInterval();
                }
            });
        } else {
            this.props.history.push({ pathname: `/home/tournamentedentry` });
        }
    }
    async loadData(sortCol) {
        let { rowKey } = this.state;
        this.setState({ isLoading: true });
        if (rowKey) {
            const tempResInfo = await fetchScoreBoardInfo(rowKey);
            const records = await fetchPlayersScoreByTournament(rowKey, sortCol);
            const members = records.filter(evt => evt.isMember === true);
            const guests = records.filter(evt => evt.isMember !== true);
            if (tempResInfo === 401) {
                this.setState({ isExpired: true })
            } else {
                const resInfo = tempResInfo.data;
                if (resInfo) {
                    this.setState({
                        records,
                        members,
                        guests,
                        Title: resInfo.title,
                        name: resInfo.golfCourseName,
                        tournamentDate: this.dateFormatter(resInfo.tournamentDate),
                        pars: resInfo.golfCoursePar.split(";").map(Number),
                        groupGuestScore: resInfo.groupGuestScore,
                        groupMemberScoreByHandicap: resInfo.groupMemberScoreByHandicap,
                        handicapValue: resInfo.handicapValue,
                        memberScoreMethod: resInfo.memberScoreMethod,
                        guestScoreMethod: resInfo.guestScoreMethod,
                        MemberHiddenHoles: resInfo.memberHiddenHoles.split(",").map(Number),
                        GuestHiddenHoles: resInfo.guestHiddenHoles.split(",").map(Number),
                        isLoading: false,
                    }, () => {
                        const { pars, MemberHiddenHoles, GuestHiddenHoles, groupMemberScoreByHandicap, members, handicapValue } = this.state;
                        const memberTotalPars = this.getHiddenHole(pars, MemberHiddenHoles).reduce((a, b) => a + b, 0);
                        const guestTotalPars = this.getHiddenHole(pars, GuestHiddenHoles).reduce((a, b) => a + b, 0);
                        this.setState({
                            memberTotalPars,
                            guestTotalPars
                        })
                        if (groupMemberScoreByHandicap === true) {
                            const membersOver = members.filter(e => e.handicapScore > handicapValue)
                            const membersUnder = members.filter(e => e.handicapScore < handicapValue)
                            this.setState({
                                membersOver,
                                membersUnder
                            })
                        }
                    });
                }
            }
        }
    }

    renderInfo() {
        const { handicapValue, showType, Title, tournamentDate, name } = this.state;
        return (
            <Row>
                {/* <Button onClick={()=>this.onClickPrintButton("pBody")} color="warning">Print</Button> */}
                <Col xs="7" lg="7">
                    <div>
                        <h6>Title :{Title} / Course :{name} / Date :{tournamentDate} <br /></h6>
                        {/* {this.state.sortColums.length > 0 &&
                            <p>{this.state.sortColums}</p>
                        } */}
                    </div>
                    {
                        showType === "member" ?
                            <h5 className="text-right">Member Score Board</h5> :
                            showType === "memberOverHandicap" ?
                                <h5 className="text-right">Member Over  Handicap{handicapValue} Score Board</h5> :
                                showType === "memberUnderHandicap" ?
                                    <h5 className="text-right">Member Under  Handicap{handicapValue} Score Board</h5> :
                                    showType === "guest" ?
                                        <h5 className="text-right">Guest Score Board</h5> :
                                        <h5 className="text-right">Score Board</h5>
                    }
                </Col>

                <Col xs="2" lg="2" className="text-right">
                    <div className='text-right' ref={this.qrcode}></div>
                </Col>
                <Col xs="3" lg="3" className="text-right">
                    <Label>
                        <InputGroup>
                            <strong>Auto Reload &nbsp;</strong>
                            <Switch checkedIcon={false} onChange={() => this.switchToggle()} checked={this.state.switchOn} onColor="#86d3ff"
                                onHandleColor="#2693e6"
                                handleDiameter={30}
                                uncheckedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={38}
                                className="react-switch"
                                id="material-switch" />
                        </InputGroup>
                    </Label>
                    &nbsp;<Button size="sm" onClick={() => this.updateState("sortColums", [])} color="warning">Reset</Button>
                    {this.state.switchOn ?
                        <Dropdown size="sm" isOpen={this.state.dropDownOpen} toggle={() => this.setState({ dropDownOpen: !this.state.dropDownOpen })}>
                            <DropdownToggle>{this.state.timerRefresh} minutes</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.updateState("timerRefresh", 0.5)}>0.5 minutes (default)</DropdownItem>
                                <DropdownItem onClick={() => this.updateState("timerRefresh", 5)}>5 minutes</DropdownItem>
                                <DropdownItem onClick={() => this.updateState("timerRefresh", 10)}>10 minutes</DropdownItem>
                            </DropdownMenu>
                        </Dropdown> :
                        ""
                    }
                </Col>
            </Row >
        );
    }
    renderAll() {

        return (this.state.records.length > 0) ?
            this.state.records.map((row, index) => {
                return (
                    <tr key={index} onClick={() => this.highLightIndex(index)} style={this.state.hlightIndex === index ? { backgroundColor: '#C8F4F8 ' } : {}}>
                        <td className="text-left">{row.playerName}</td>
                        <td className="text-left">{row.isMember === true ? "Member" : "Guest"}</td>
                        <td></td>
                        <td><span style={this.getScoreColor(1, row.hole1, this.state.pars[0])}>{row.hole1}</span></td>
                        <td><span style={this.getScoreColor(2, row.hole2, this.state.pars[1])}>{row.hole2}</span></td>
                        <td><span style={this.getScoreColor(3, row.hole3, this.state.pars[2])}>{row.hole3}</span></td>
                        <td><span style={this.getScoreColor(4, row.hole4, this.state.pars[3])}>{row.hole4}</span></td>
                        <td><span style={this.getScoreColor(5, row.hole5, this.state.pars[4])}>{row.hole5}</span></td>
                        <td><span style={this.getScoreColor(6, row.hole6, this.state.pars[5])}>{row.hole6}</span></td>
                        <td><span style={this.getScoreColor(7, row.hole7, this.state.pars[6])}>{row.hole7}</span></td>
                        <td><span style={this.getScoreColor(8, row.hole8, this.state.pars[7])}>{row.hole8}</span></td>
                        <td><span style={this.getScoreColor(9, row.hole9, this.state.pars[8])}>{row.hole9}</span></td>
                        <td><span style={row.is1stConerChecked ? { color: "green", fontWeight: "bold" } : { color: 'red', fontWeight: "bold" }}>{row.firstConerSubTotal}</span></td>
                        <td><span style={this.getScoreColor(10, row.hole10, this.state.pars[9])}>{row.hole10}</span></td>
                        <td><span style={this.getScoreColor(11, row.hole11, this.state.pars[10])}>{row.hole11}</span></td>
                        <td><span style={this.getScoreColor(12, row.hole12, this.state.pars[11])}>{row.hole12}</span></td>
                        <td><span style={this.getScoreColor(13, row.hole13, this.state.pars[12])}>{row.hole13}</span></td>
                        <td><span style={this.getScoreColor(14, row.hole14, this.state.pars[13])}>{row.hole14}</span></td>
                        <td><span style={this.getScoreColor(15, row.hole15, this.state.pars[14])}>{row.hole15}</span></td>
                        <td><span style={this.getScoreColor(16, row.hole16, this.state.pars[15])}>{row.hole16}</span></td>
                        <td><span style={this.getScoreColor(17, row.hole17, this.state.pars[16])}>{row.hole17}</span></td>
                        <td><span style={this.getScoreColor(18, row.hole18, this.state.pars[17])}>{row.hole18}</span></td>
                        <td><span style={row.is2ndConerChecked ? { color: "green", fontWeight: "bold" } : { color: 'red', fontWeight: "bold" }}>{row.secondConerSubTotal}</span></td>
                        <td>{row.totalScore}</td>
                        <td>{row.handicapScore}</td>
                        <td>{row.nett}</td>
                        <td>{row.score}</td>
                        <td>{row.parCount}</td>
                        <td>{row.bardieCount}</td>
                    </tr>
                );
            }) : ""
    }
    highLightIndex(index) {
        this.setState({ hlightIndex: this.state.hlightIndex === index ? -1 : index, })
    }
    renderFilteredData(prop) {
        let { members, membersOver, membersUnder, guests } = this.state;
        var renderObj;
        if (prop === "members")
            renderObj = members
        else if (prop === "membersOver")
            renderObj = membersOver
        else if (prop === "membersUnder")
            renderObj = membersUnder
        else if (prop === "guests")
            renderObj = guests
        // this.setState({ renderObj })
        return (renderObj.length > 0) ?
            renderObj.map((row, index) => {
                return (
                    <tr key={index} onClick={() => this.highLightIndex(index)} style={this.state.hlightIndex === index ? { backgroundColor: '#C8F4F8 ' } : {}}>
                        <td className="text-left">{row.playerName}</td>
                        <td></td>
                        <td><span style={this.getScoreColor(1, row.hole1, this.state.pars[0])}>{row.hole1}</span></td>
                        <td><span style={this.getScoreColor(2, row.hole2, this.state.pars[1])}>{row.hole2}</span></td>
                        <td><span style={this.getScoreColor(3, row.hole3, this.state.pars[2])}>{row.hole3}</span></td>
                        <td><span style={this.getScoreColor(4, row.hole4, this.state.pars[3])}>{row.hole4}</span></td>
                        <td><span style={this.getScoreColor(5, row.hole5, this.state.pars[4])}>{row.hole5}</span></td>
                        <td><span style={this.getScoreColor(6, row.hole6, this.state.pars[5])}>{row.hole6}</span></td>
                        <td><span style={this.getScoreColor(7, row.hole7, this.state.pars[6])}>{row.hole7}</span></td>
                        <td><span style={this.getScoreColor(8, row.hole8, this.state.pars[7])}>{row.hole8}</span></td>
                        <td><span style={this.getScoreColor(9, row.hole9, this.state.pars[8])}>{row.hole9}</span></td>
                        <td><span style={row.is1stConerChecked ? { fontWeight: "bold" } : { fontWeight: "bold", color: "grey" }}>{row.firstConerSubTotal}</span></td>
                        <td><span style={this.getScoreColor(10, row.hole10, this.state.pars[9])}>{row.hole10}</span></td>
                        <td><span style={this.getScoreColor(11, row.hole11, this.state.pars[10])}>{row.hole11}</span></td>
                        <td><span style={this.getScoreColor(12, row.hole12, this.state.pars[11])}>{row.hole12}</span></td>
                        <td><span style={this.getScoreColor(13, row.hole13, this.state.pars[12])}>{row.hole13}</span></td>
                        <td><span style={this.getScoreColor(14, row.hole14, this.state.pars[13])}>{row.hole14}</span></td>
                        <td><span style={this.getScoreColor(15, row.hole15, this.state.pars[14])}>{row.hole15}</span></td>
                        <td><span style={this.getScoreColor(16, row.hole16, this.state.pars[15])}>{row.hole16}</span></td>
                        <td><span style={this.getScoreColor(17, row.hole17, this.state.pars[16])}>{row.hole17}</span></td>
                        <td><span style={this.getScoreColor(18, row.hole18, this.state.pars[17])}>{row.hole18}</span></td>
                        <td><span style={row.is2ndConerChecked ? { fontWeight: "bold", color: "green" } : { fontWeight: "bold", color: "red" }}>{row.secondConerSubTotal}</span></td>
                        <td>{row.totalScore}</td>
                        <td>{row.handicapScore}</td>
                        <td>{row.nett}</td>
                        <td>{row.score}</td>
                        <td>{row.parCount}</td>
                        <td>{row.bardieCount}</td>
                    </tr>
                );
            }) : ""
    }
    switchToggle() {
        this.setState({
            switchOn: !this.state.switchOn,
        }, () => {
            if (!this.state.switchOn) {
                clearInterval(this.state.myInterval);
            } else {
                this.createInterval();
            }
        })
    }
    updateState(prop, value) {
        if (prop === "sort") {
            if (!this.state.sortColums.includes(value) && !this.state.sortColums.includes(`${value} DESC`))
                this.setState({ sortColums: [...this.state.sortColums, value] }, () => {
                    this.loadData(this.state.sortColums)
                })
            else {
                let newSortData = this.state.sortColums.map((itm, idx) => {
                    if (itm === value)
                        itm = `${value} DESC`
                    else if (itm === `${value} DESC`) {
                        itm = itm.substring(0, itm.indexOf(" "))
                    }
                    return itm
                })
                this.setState({ sortColums: newSortData }, () => {
                    this.loadData(this.state.sortColums)
                })
            }
        } else {
            this.setState({ [prop]: value }, () => {
                if (prop === "timerRefresh") {
                    clearInterval(this.state.myInterval);
                    this.createInterval();
                }
                if (prop === "sortColums")
                    this.loadData(this.state.sortColums)
            });
        }
    }
    render() {
        const sortCol = this.state.sortBy[1];
        let { showType, sortColums } = this.state;
        return (
            <Row id="pBody">
                <Col lg="8">
                    <Card>
                        {this.state.isLoading && <LoadingSpinner />}
                        {this.state.isExpired && <AlertExpire />}
                        <CardBody>
                            {this.renderInfo()}
                            <Table className="table-sm text-center scoreList" responsive striped>
                                <thead>
                                    <tr>
                                        <th bgcolor={sortColums.includes("playerName") ? "#e6ffff" : "#C8F4F8"}
                                            className="text-left canSort" onClick={() => this.updateState("sort", "playerName")} >
                                            Name
                                        </th>
                                        {this.state.showType === "all" ?
                                            <th bgcolor={sortColums.includes("isMember") ? "#e6ffff" : "#C8F4F8"}
                                                className="text-left canSort" onClick={() => this.updateState("sort", "isMember")}>
                                                Type
                                            </th> : ""
                                        }
                                        <th bgcolor="#C8F4F8">Hole<br /><span>Par</span></th>
                                        {this.state.pars.map((i, index) => {
                                            return ([
                                                <th bgcolor={sortColums.includes(`hole${index + 1}`) ? "#e6ffff" : "#C8F4F8"} className="canSort" onClick={() => this.updateState("sort", `hole${index + 1}`)} key={index}>
                                                    {index + 1}<br /><span style={this.getScoreColor(index + 1)}>{i}</span>
                                                </th>,
                                                (index + 1 === 9 || index + 1 === 18) ?
                                                    <th bgcolor="#C8F4F8" key={-index}>
                                                        Out<br /><span>
                                                            {this.getSubTotal(this.state.pars, this.state.MemberHiddenHoles, index + 1)}
                                                        </span>
                                                    </th> : null
                                            ]);
                                        })}
                                        <th bgcolor={sortColums.includes("totalScore") ? "#e6ffff" : "#C8F4F8"} className="canSort"
                                            onClick={() => this.updateState("sort", "totalScore")} >
                                            Total<br />
                                            <span>M:{this.state.memberTotalPars}/ G:{this.state.guestTotalPars}</span>
                                        </th>
                                        <th bgcolor={sortColums.includes("handicapScore") ? "#e6ffff" : "#C8F4F8"} className="canSort"
                                            onClick={() => this.updateState("sort", "handicapScore")} >
                                            H`Cap
                                        </th>
                                        <th bgcolor={sortColums.includes("nett") ? "#e6ffff" : "#C8F4F8"} className="canSort"
                                            onClick={() => this.updateState("sort", "nett")}>
                                            Nett
                                        </th>
                                        <th bgcolor={sortColums.includes("score") ? "#e6ffff" : "#C8F4F8"} className="canSort"
                                            onClick={() => this.updateState("sort", "score")}>
                                            Score
                                        </th>
                                        <th bgcolor={sortColums.includes("parCount") ? "#e6ffff" : "#C8F4F8"} className="canSort"
                                            onClick={() => this.updateState("sort", "parCount")}>
                                            Par
                                        </th>
                                        <th bgcolor={sortColums.includes("bardieCount") ? "#e6ffff" : "#C8F4F8"} className="canSort"
                                            onClick={() => this.updateState("sort", "bardieCount")}>
                                            Bardie
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        showType === "member" ?
                                            this.renderFilteredData("members") :
                                            showType === "memberOverHandicap" ?
                                                this.renderFilteredData("membersOver") :
                                                showType === "memberUnderHandicap" ?
                                                    this.renderFilteredData("membersUnder") :
                                                    showType === "guest" ?
                                                        this.renderFilteredData("guests") :
                                                        this.renderAll()
                                    }
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
                <Col lg="4" sm="12">
                    {(this.state.sponsorsImages.length > 0) ?
                        <Card>
                            <Container>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        height: "100vh",
                                        margin: "auto",
                                    }}
                                >   <strong style={{ color: '#357EC7' }}>Our Main Sponsors</strong> <hr />
                                    <VerticalCarousel
                                        slides={this.state.sponsorsImages}
                                        offsetRadius={2}
                                        autoSlide={10}
                                    />
                                </div>
                            </Container>
                        </Card>
                        :
                        <Card>
                            <div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    height: "100vh",
                                    margin: "auto",
                                }}
                            >   <strong style={{ color: '#357EC7' }}>Sponsors Ads Here</strong>
                            </div>
                        </Card>
                    }
                </Col>
            </Row >
        );
    }

    dateFormatter(date) {
        if (date) return moment(date).local().format("YYYY/MM/DD");
        else return '';
    }
    toggleDropDown() {
        let { dropDownOpen } = this.state;
        this.setState({
            dropDownOpen: !dropDownOpen,
        })
    }

    backHandle = () => {
        this.props.history.push({ pathname: `/r/home/tournamentedEntry` });
    }
    getHiddenHole(holes, hiddenHoles) {
        let hideHoles = holes.filter((h, index) => { return hiddenHoles.includes(index + 1) });
        return hideHoles;
    }
    calculateScore(resList) {
        const { pars, memberScoreMethod, guestScoreMethod, MemberHiddenHoles, GuestHiddenHoles } = this.state;
        const memberTotalPars = this.getHiddenHole(pars, MemberHiddenHoles).reduce((a, b) => a + b, 0);
        const guestTotalPars = this.getHiddenHole(pars, GuestHiddenHoles).reduce((a, b) => a + b, 0);
        const memberCount = resList.filter((row) => { return row.isMember === true }).length;
        const guestCount = resList.filter((row) => { return row.isMember === false }).length;
        for (let i = 0; i < resList.length; i++) {
            let totalScore = resList[i].holes.reduce((a, b) => a + b, 0);
            switch (resList[i].isMember === true ? memberScoreMethod : guestScoreMethod) {
                case "System36":
                    const hiddenHolelist = this.getHiddenHole(resList[i].holes, resList[i].isMember === true ? MemberHiddenHoles : GuestHiddenHoles);
                    totalScore = hiddenHolelist.reduce((a, b) => a + b, 0);
                    // console.log("total score", totalScore);
                    //filter pars for hidden holes
                    var newPars = [];
                    var hidHoles = resList[i].isMember === true ? MemberHiddenHoles : GuestHiddenHoles;
                    for (let index = 0; index < hidHoles.length; index++) {
                        const value = hidHoles[index];
                        if (value !== 0)
                            newPars.push(pars[index]);
                    }
                    //end
                    resList[i].handiCap = this.calculateHandicap(hiddenHolelist, newPars, totalScore);
                    // resList[i].ParCount = this.calculatePar(hiddenHolelist,newPars);
                    // resList[i].BardieCount = this.calculateBardie(hiddenHolelist,newPars);
                    resList[i].ParCount = this.calculatePar(resList[i].holes, pars);
                    resList[i].BardieCount = this.calculateBardie(resList[i].holes, pars);
                    // console.log("HC", resList[i].Handicap);
                    break;
                default: break;
            }
            resList[i].totalScore = totalScore;
            resList[i].nett = totalScore - resList[i].handiCap;
            resList[i].score = totalScore - resList[i].handiCap - (resList[i].isMember === true ? memberTotalPars : guestTotalPars);
        }
        const member = resList.filter(evt => evt.isMember === true);
        const guest = resList.filter(evt => evt.isMember !== true);
        this.setState({
            memberTotalPars: memberTotalPars,
            guestTotalPars: guestTotalPars,
            memberCount: memberCount,
            guestCount: guestCount,
            data: resList,
            members: member,
            guests: guest,
            isLoading: false,
        }, () => {
            let { groupMemberScoreByHandicap, members, handicapValue } = this.state;
            if (groupMemberScoreByHandicap === true) {
                const membersOver = members.filter(e => e.handiCap > handicapValue)
                const membersUnder = members.filter(e => e.handiCap < handicapValue)
                this.setState({
                    membersOver,
                    membersUnder
                })
            }
        });
    }

    getSubTotal(holes, hiddenHoles, holeNum) {
        return holes.filter((row, index) => {
            return holeNum - 9 <= index && index < holeNum && hiddenHoles.includes(index + 1)
        }).reduce((a, b) => a + b, 0);
    }
    getScoreColor(holeNum, score, par) {
        if (this.state.MemberHiddenHoles.includes(holeNum) || this.state.GuestHiddenHoles.includes(holeNum)) {
            let scoreColor = "#33ccff";
            if (!isNaN(score) && !isNaN(score)) {
                if (score === 0) {
                    scoreColor = "transparent";
                }
                else if (par === score) { // par
                    scoreColor = "#66ff66";
                }
                else if (par - 1 === score) { // bardie
                    scoreColor = "#d9b3ff";
                }
                else if (par - 2 >= score) { // eable
                    scoreColor = "#ffd700";
                }
                else if (par + 1 === score) { // boggy
                    scoreColor = "#33ccff";
                }
                else if (par + 2 <= score) { // double and above
                    scoreColor = "#f8fc03";
                }
            }
            return {
                borderRadius: 2,
                backgroundColor: scoreColor,
                padding: "0px 6px 0px",
            };
        } else {
            return null;
        }
    }

    sortBy(sortCol) {
        let { showType, members, membersOver, membersUnder, guests, records, sortData } = this.state;
        let isAsc = this.state.sortBy[1] === sortCol ? !this.state.sortBy[0] : true;
        //console.log("sortCol",sortCol);
        //console.log("data",this.state.data);
        if (showType === "member") {
            sortData = members
        }
        else if (showType === "memberOverHandicap") {
            sortData = membersOver

        }
        else if (showType === "memberUnderHandicap") {
            sortData = membersUnder
        }
        else if (showType === "guest") {
            sortData = guests
        }
        else {
            sortData = records
        }
        this.setState({
            sortData: sortData.sort((row1, row2) => {
                if (isNaN(row1[sortCol]) || isNaN(row2[sortCol]))
                    return isAsc ? row1[sortCol].localeCompare(row2[sortCol]) : row2[sortCol].localeCompare(row1[sortCol]);
                else
                    return isAsc ? row1[sortCol] - row2[sortCol] : row2[sortCol] - row1[sortCol]
            }),
            sortBy: [isAsc, sortCol],
        })
    }
}
function mapStateToProps(state) {
    return { auth: state.auth };
}


export default connect(mapStateToProps, actions)(MasterScoreBoard);